module.exports = __webpack_public_path__ + "img/golverto-vicente.39b27bfe.png";